import React from 'react';
import MainHeader from './MainHeader';
import MainContainer from './MainContainer';
import ProjectNavigation from './ProjectTopMenu';

const CompletePageLayout = ({ 
  projectId, 
  activeTab = 'walkthrough',
  title = "PROJECT",
  hideNavigation = false,
  hideHeader = false,
  onAddRoom,
  children 
}) => {
  // The sheet label (e.g. "FF&E") is everything before the " - CLIENT" in the
  // title; the consolidated header now shows it once with the name + address.
  const sheetLabel = String(title || '').split(' - ')[0];
  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black">
      {!hideHeader && (
        <MainHeader 
          projectId={projectId}
          activeTab={activeTab}
          hideNavigation={true}
          sheetLabel={sheetLabel}
        />
      )}
      
      {/* Project Navigation with Dropdowns */}
      {!hideNavigation && projectId && (
        <ProjectNavigation projectId={projectId} activeTab={activeTab} />
      )}
      
      <div style={{ marginTop: 0 }}>
        <MainContainer
          title={hideHeader ? title : ''}
          hideNavigation={hideNavigation}
          onAddRoom={onAddRoom}
          projectId={projectId}
        >
          {children}
        </MainContainer>
      </div>
    </div>
  );
};

export default CompletePageLayout;